import { render, staticRenderFns } from "./MinisterList.vue?vue&type=template&id=d486c664&"
import script from "./MinisterList.vue?vue&type=script&lang=js&"
export * from "./MinisterList.vue?vue&type=script&lang=js&"
import style0 from "./MinisterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports